  function accordions() {
    document.querySelectorAll('details').forEach((accordion) => {
      if (accordion) {
        accordion.addEventListener('toggle', function () {
          this.setAttribute('aria-expanded', this.open ? 'true' : 'false');
        });
      }
    });
  }
  function searchBarToggle() {
    const searchIcon = document.querySelector('.tt-toggle__desktop');
    const searchWrapper = document.querySelector('.custom-search-bar');
    if (!searchIcon || !searchWrapper) return;
    if (searchIcon) {
      searchIcon.addEventListener('click', () => {
        searchWrapper.classList.toggle('active');
      });
    }
    document.addEventListener('click', (e) => {
      if (!searchWrapper.contains(e.target) && !searchIcon.contains(e.target)) {
        searchWrapper.classList.remove('active');
      }
    });
  }
  function productSubmit() {
    const cartToggleBtn = document.querySelector('.cart-icon__toggle');
    const cartDrawerContainer = document.querySelector('.cart-drawer__wrapper');
    const cartDrawerBox = document.querySelector('.cart-drawer__box');
    const cartDrawerClose = document.querySelector('.cart-drawer__wrapper .cart-close');
    if (cartToggleBtn && cartDrawerContainer) {
      cartToggleBtn.addEventListener('click', () => {
        cartDrawerContainer.classList.add('active');
      });
    }
    if (cartDrawerContainer) {
      cartDrawerContainer.addEventListener('click', () => {
        cartDrawerContainer.classList.remove('active');
      });
    }
    if (cartDrawerBox) {
      cartDrawerBox.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
    if (cartDrawerClose) {
      cartDrawerClose.addEventListener('click', () => {
        cartDrawerContainer.classList.remove('active');
      });
    }
  }
  const moneyFormat = '$';
  function formatMoney$1(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    
    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
          return 0;
        }
      
        number = (number / 100.0).toFixed(precision);
      
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';
      
        return dollarsAmount + centsAmount;
      }
    
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    
    return formatString.replace(placeholderRegex, value);
  }
  var formatMoney = (val => formatMoney$1(val, window.themeContent.routes.money_format || "$"));
  function doApplyDiscountInDrawer() {
    var input = document.getElementById('cart_discount_code');
    var btn = document.getElementById('apply_cart_discount');
    var msg = document.getElementById('cart_discount_msg');
    var discountContainer = document.querySelector('.cart-discount__container');
    var subtotalContainer = document.querySelector('.cart-subtotal__container');
    var discountPrice = discountContainer ? discountContainer.querySelector('[data-discount]') : null;

    var discountTagWrapper = document.createElement('div');
    discountTagWrapper.className = 'cart-discount-tag hide';
    discountTagWrapper.innerHTML = `
      <span class="discount-badge">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 3h8l5 5-8 8-5-5V3z"></path>
        </svg>
        <span class="discount-code-label"></span>
        <button class="remove-discount" title="Remove discount">&times;</button>
      </span>
    `;
    var orderSummary = document.querySelector('.tt-cart-total-row');
    if (orderSummary) orderSummary.parentNode.insertBefore(discountTagWrapper, orderSummary);

    if (!btn || !input) return;

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function fetchCart(callback) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', true);
      xhr.setRequestHeader('Cache-Control', 'no-store');
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          try {
            var cart = JSON.parse(xhr.responseText);
            callback(cart);
          } catch (e) {
            console.error('Error parsing cart.js:', e);
          }
        }
      };
      xhr.send();
    }

    function updateCartTotals(cart) {
      var subtotalEl = subtotalContainer ? subtotalContainer.querySelector('[data-subTotal]') : null;
      var totalEl = document.querySelector('[data-total]');

      if (subtotalEl) subtotalEl.innerHTML = '<span class="money">' + formatMoney(cart.items_subtotal_price) + '</span>';
      if (discountPrice) discountPrice.innerHTML = '-<span class="money">' + formatMoney(cart.total_discount) + '</span>';
      if (totalEl) totalEl.innerHTML = '<span class="money">' + formatMoney(cart.total_price) + '</span>';

      if (cart.total_discount > 0) {
        subtotalContainer && subtotalContainer.classList.remove('hide');
        discountContainer && discountContainer.classList.remove('hide');
      } else {
        subtotalContainer && subtotalContainer.classList.add('hide');
        discountContainer && discountContainer.classList.add('hide');
      }
    }

    
    
    function showDiscountTag(code, cart) {
      const label = discountTagWrapper.querySelector('.discount-code-label');
      const displayCode = (code || 'DISCOUNT').toString().trim().toUpperCase();

      label.textContent = displayCode;
      discountTagWrapper.classList.remove('hide');

      subtotalContainer?.classList.remove('hide');
      discountContainer?.classList.remove('hide');

      updateCartTotals(cart);
    }

    function hideDiscountTag() {
      discountTagWrapper.classList.add('hide');
      subtotalContainer && subtotalContainer.classList.add('hide');
      discountContainer && discountContainer.classList.add('hide');
    }

    
    function checkExistingDiscount() {
      fetchCart(function(cart) {
        if (cart.total_discount > 0) {
          let code = 'DISCOUNT';

          if (cart.cart_level_discount_applications?.length) {
            const app = cart.cart_level_discount_applications[0];
            code = app.code || app.title || 'DISCOUNT';
          } else if (cart.discount_applications?.length) {
            const app = cart.discount_applications[0];
            code = app.code || app.title || 'DISCOUNT';
          }

          showDiscountTag(code, cart);
        } else {
          hideDiscountTag();
          updateCartTotals(cart);
        }
      });
    }

    btn.addEventListener('click', function() {
      var code = input.value.trim();
      if (!code) {
        msg.textContent = 'Please enter a discount code.';
        msg.style.color = 'red';
        return;
      }

      var popup = window.open('/discount/' + encodeURIComponent(code) + '?redirect=/cart', '_blank', 'width=1,height=1,left=-1000,top=-1000');

      var start = Date.now();
      var interval = setInterval(function() {
        fetchCart(function(cart) {
          if (cart.total_discount > 0 || Date.now() - start > 7000) {
            clearInterval(interval);
            if (popup) popup.close();
            if (cart.total_discount > 0) {
              showDiscountTag(code, cart);
            } else {
            }
            input.value = '';
          }
        });
      }, 500);
    });

    
    

    discountTagWrapper.querySelector('.remove-discount').addEventListener('click', function() {
      const redirectUrl = '/discount/none?redirect=' + encodeURIComponent(window.location.pathname);
      window.location.href = redirectUrl;
    });

    checkExistingDiscount();

    window.addEventListener('pageshow', function(event) {
      if (event.persisted) checkExistingDiscount();
    });
  }

  function initCartForm() {
    let selectors = {
      quantitySelector: document.querySelectorAll('.tt-quantity-selector button'),
      cartContainer: document.querySelectorAll('[data-cart]'),
      cartForm: document.querySelectorAll('#cart_form'),
      cartItemCounter: document.querySelectorAll('.tt-badge-cart'),
      removeButton: document.querySelectorAll('.cart__item-remove'),
    };
  
    
    selectors.removeButton.forEach(button => {
      if (!button) {
        return
      }
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const itemToRemove = button.closest('[data-key]');
        const key = itemToRemove.dataset.key;
        removeItem(key,0,itemToRemove);
      });
    });

    document.querySelectorAll('.cart-checkout__btn').forEach(btn => {
      if (!btn || btn.dataset.termsHandlerBound === 'true') return;
      btn.dataset.termsHandlerBound = 'true';
      if (btn) {
        btn.addEventListener('click', (e) => {
          const termsBox = document.querySelector('[data-checkout-terms]');
          const checkbox = termsBox ? termsBox.querySelector('input[type="checkbox"]') : null;

          if (termsBox && checkbox && !checkbox.checked) {
            e.preventDefault();
            alert('Please agree to the Terms and Conditions before proceeding.');
            checkbox.focus();
            return false;
          }
        });
      }
      
    });
    
    function updateCart(key,quantity) {
      var requestData = {
        id: key,
        quantity: quantity
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestData)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cartData) {
        updateSubtotal(cartData);
        updateCartCount(cartData);
        toggleEmptyCartState(cartData);
        doApplyDiscountInDrawer();
      })
      .catch(function(error) {
        console.error('Error updating cart:', error);
      });
    } 
  
    function removeItem(key, quantity, itemToRemove) {
      var requestData = {
        id: key,
        quantity: 0,
        itemToRemove: itemToRemove
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestData)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cartData) {
        removeLineItem(cartData.items, itemToRemove);
        updateSubtotal(cartData);
        updateCartCount(cartData);
        toggleEmptyCartState(cartData);
      })
      .catch(function(error) {
        console.error('Error updating cart:', error);
      });
    }

    function updateSubtotal(cartData) {
      const newFormatted = formatMoney(cartData.total_price);

      document.querySelectorAll('[data-subTotal]').forEach(el => {
        const moneyEl = el.querySelector('.money');
        if (moneyEl) {
          moneyEl.innerHTML = newFormatted;
        } else {
          el.innerHTML = `<span class="money">${newFormatted}</span>`;
        }
      });
    }
    function updateCartCount(cartData) {
      selectors.cartItemCounter.forEach(counter => {
        if (!counter) {
          return;
        }
        if (cartData.item_count > 0) {
          
          counter.textContent = cartData.item_count;
          counter.classList.remove('hidden');
        } else {
          counter.remove();
        }
      })
    }
  
    function formSubmit(event,checkedInput) {
      if (!checkedInput) {
        return;
      }
      if (checkedInput.checked) {
      } else {
        alert('You must agree with the terms and conditions to continue.');
        event.preventDefault();
      }
    }
  
    function removeLineItem(items,itemToRemove) {
      selectors.cartContainer.forEach(container => {
        if (container) {
          const cartFormContent = container.querySelector('.tt-cart-list');
          const emptyCart = document.createElement('div');
          emptyCart.className = 'cart-drawer__empty';
          emptyCart.innerHTML = `
            <div class="tt-cart-empty">
              <i class="icon-f-40"></i>
              <p>YOUR BAG IS EMPTY</p>
            </div>
          `;
          if (items.length === 0) {
            if (cartFormContent) {
              cartFormContent.remove();
            }
            container.appendChild(emptyCart);
          } else {
            if (itemToRemove) {
              itemToRemove.remove();
            } else {
              console.warn('Item to remove not found in DOM.');
            }
            
          }
        }
      });
    } 

    function toggleEmptyCartState(cartData) {
      document.querySelectorAll('[data-cart-modal]').forEach(drawer => {
        if (cartData && cartData.item_count > 0) {
          drawer.classList.remove('cart-drawer__empty');
        } else {
          drawer.classList.add('cart-drawer__empty');
        }
      });
    } 



  }

  function initProductForm() {
    let selectors = {
      productForm: document.querySelectorAll(`form[action="${window.themeContent.routes.cartAddedUrl}"]`),
      cartDrawer: document.querySelectorAll('[data-cart-modal]'),
      closeDrawerBtn: document.querySelectorAll('.cart-drawer__wrapper .cart-close'),
      cartBox: document.querySelector('[data-cart-modal] .cart-drawer__box'),
      bodyContainer: document.querySelector('body'),
      cartItemCounter: document.querySelectorAll('.tt-badge-cart'),
      cartDrawerContent: document.querySelector("[data-cart]")
    };
    selectors.cartDrawer.forEach(drawer => {
      if (!drawer) return;
      drawer.addEventListener('click', () => {
        closeCartDrawer();
      });
    });
    if (selectors.cartBox) {
      selectors.cartBox.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  
    selectors.closeDrawerBtn.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          closeCartDrawer();
        });
      }
    });
  
    selectors.productForm.forEach(form => {
      if (!form) {
        return;
      }
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        await submitProductForm(form);
      });
      
    });

    async function submitProductForm(form) {
      try {
        openCartDrawer();
        selectors.bodyContainer.classList.add('adding-to-cart');

        const addPromise = fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        const addRes = await addPromise;
        const [cartRes, sectionRes] = await Promise.all([
          fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
          fetch('/?section_id=ajax-cart')
        ]);

        const cartData = await cartRes.json();
        const sectionText = await sectionRes.text();

        selectors.cartDrawer.forEach(drawer => {
          if (cartData.item_count > 0) {
            drawer.classList.remove('cart-drawer__empty');
          } else {
            drawer.classList.add('cart-drawer__empty');
          }
        });

        updateDrawerSubtotal(cartData);
        cartItemCount(cartData);

        if (sectionText) {
          const html = document.createElement('div');
          html.innerHTML = sectionText;
          const newCart = html.querySelector('[data-cart]');
          if (newCart && selectors.cartDrawerContent) {
            selectors.cartDrawerContent.innerHTML = newCart.innerHTML;
          }
        }

        setTimeout(() => {
          initCartForm();
          doApplyDiscountInDrawer();
        }, 30);
      } catch (err) {
        console.error('submitProductForm error:', err);
      } finally {
        selectors.bodyContainer.classList.remove('adding-to-cart');
      }
    }

    async function updateCartDrawer() {
      const res = await fetch("/?section_id=ajax-cart");
      const text = await res.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      const newBox = html.querySelector("[data-cart]").innerHTML;
      if (selectors.cartDrawerContent) {
        selectors.cartDrawerContent.innerHTML = newBox;
      }
      initCartForm();
      setTimeout(() => {
        doApplyDiscountInDrawer();
      }, 50);
    }
    function openCartDrawer() {
      selectors.cartDrawer.forEach(drawer => {
        if (drawer) {
          drawer.classList.add('active');
          selectors.bodyContainer.classList.add('drawer__opening');
        }
      });
    }
    function closeCartDrawer() {
      selectors.cartDrawer.forEach(drawer => {
        if (drawer) {
          drawer.classList.remove('active');
          selectors.bodyContainer.classList.remove('drawer__opening');
        }
      });
    }
    function cartItemCount(cartData) {
      selectors.cartItemCounter.forEach(counter => {
        if (!counter) {
          return;
        }
        if (cartData.item_count > 0) {
          counter.textContent = cartData.item_count;
          counter.classList.remove('hide');
        } else {
          counter.remove();
        }
        
      })
    }
    function updateDrawerSubtotal(cartData) {
      const newFormatted = formatMoney(cartData.total_price);
      document.querySelectorAll('[data-subTotal]').forEach(el => {
        const moneyEl = el.querySelector('.money');
        if (moneyEl) {
          moneyEl.innerHTML = newFormatted;
        } else {
          el.innerHTML = `<span class="money">${newFormatted}</span>`;
        }
      });
    }

  }

  document.addEventListener('DOMContentLoaded', () => {
    accordions();
    searchBarToggle();
    productSubmit();
    doApplyDiscountInDrawer();
    initCartForm();
    initProductForm();
  });
